import React from 'react'
import { Card, Avatar } from 'antd';
const { Meta } = Card;
function SubjectCard(props) {

  let {itemname, staffname} = props.data || ''
  return (
    <Card
      style={{width:'330px',  margin:'10px' }}
      // cover={
      //   <img
      //     alt="example"
      //     src="https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png"
      //   />
      // }
      actions={[
        <span onClick={()=>props.loadPlans(props.data)}>LESSONS</span>,
        <span onClick={()=>props.loadTest(props.data)}>TEST</span>,
      ]}
  >
    <Meta
      avatar={<Avatar src="https://joeschmoe.io/api/v1/random" />}
      title={itemname}
      description={staffname}
      style={{textAlign:'left', fontWeight:'bolder', color:'green'}}
    />
  </Card>
  )
}

SubjectCard.propTypes = {}

export default SubjectCard



